<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { API, ENV } from '../env/externals'
import { useI18n } from 'vue-i18n'
import { usePayrollChange } from '@/app/core/composable/routes/useChangePayroll'
import { DBtn } from 'front-library'
import { usePayrollStore } from '@/store/payroll-data'
import { useUserStore } from '@/store/user'

const externalIframe = API[ENV()]()

usePayrollChange(() => back())

const router = useRouter()
const iframeUrl = ref('')
const { t } = useI18n()

onMounted(async () => {
  const payrollStore = usePayrollStore()
  const userStore = useUserStore()
  const authorization = await userStore.getValidToken()

  iframeUrl.value = `${externalIframe}/reports`
  iframeUrl.value += `?token=${authorization}`
  iframeUrl.value += `&countryId=${payrollStore.payroll?.country.iso_code}`
  iframeUrl.value += `&companyId=${payrollStore.payroll?.company.id}`
})

const back = () => {
  router.back()
}
</script>
<template>
  <div class="h-full px-5 pt-16 pb-5 flex flex-col">
    <iframe :src="iframeUrl" title="Dashboard" class="w-full h-full"></iframe>
    <div class="w-full bg-white p-5">
      <DBtn
        type="button"
        color="secondary"
        @click="back"
        class="px-5 py-2 font-semibold cursor-pointer"
        v-html="t('form.button.back')" />
    </div>
  </div>
</template>
